'use strict';

function parse(reader) {
    reader.readUInt8('data.params.tcp_keep_alive_interval');
    reader.readUInt8('data.params.custom_keep_alive_package.enabled', value => value === 1);
    reader.readUInt8('data.params.custom_keep_alive_package.with_response', value => value === 1);
    reader.readString(64, 'data.params.custom_keep_alive_package.request_content');
    reader.readString(64, 'data.params.custom_keep_alive_package.response_content');
    reader.readUInt16LE('data.params.custom_keep_alive_package.interval');
    reader.readUInt16LE('data.params.server_1_port');
    reader.readUInt16LE('data.params.server_2_port');
    reader.readUInt32LE('data.params.server_1_ip');
    reader.readUInt32LE('data.params.server_2_ip');
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_2/common/rule/tcp-udp-config-parser.js